<template>
  <svg
    :class="classes"
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3c0-.552.449-1.005.998-.95A10 10 0 0 1 12 22v-2a7.999 7.999 0 0 0 .997-15.938C12.45 3.994 12 3.552 12 3Z"
      :fill="`url(#${spinnerIdA})`"
    />
    <path
      d="M12 22A10 10 0 0 1 5.344 4.537c.412-.368 1.041-.265 1.366.182.325.447.22 1.068-.183 1.446A8 8 0 0 0 12 20v2Z"
      :fill="`url(#${spinnerIdB})`"
    />
    <defs>
      <linearGradient
        :id="spinnerIdA"
        gradientUnits="userSpaceOnUse"
        x1="12"
        x2="12"
        y1="20"
        y2="3.5"
      >
        <stop class="spinner-stop-color"/>
        <stop
          class="spinner-stop-color"
          offset="1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        :id="spinnerIdB"
        gradientUnits="userSpaceOnUse"
        x1="12"
        x2="12"
        y1="4.5"
        y2="20"
      >
        <stop class="spinner-stop-color"/>
        <stop
          class="spinner-stop-color"
          offset="1"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
import { COLOR_SECONDARY, SIZE_MD } from '../../config/constants';
import uidMixin from '../../mixins/uid.mixin';
import { SPINNER_BASE_CLASS, SPINNER_COLORS, SPINNER_SIZES } from './config';

export default {
  name: 'DpSpinner',

  mixins: [
    uidMixin,
  ],

  props: {
    /**
     * @values sm, md, lg
     * @default md
     * */
    size: {
      type: String,
      required: false,
      default: SIZE_MD,
      validator: (value) => SPINNER_SIZES.includes(value),
    },
    /**
     * @values secondary, gray-300, white
     * @default secondary
     * */
    color: {
      type: String,
      required: false,
      default: COLOR_SECONDARY,
      validator: (value) => SPINNER_COLORS.includes(value),
    },
  },

  computed: {
    spinnerIdA() {
      return `spinner_${this._uid}_a`;
    },
    spinnerIdB() {
      return `spinner_${this._uid}_b`;
    },
    classes() {
      const classes = [
        SPINNER_BASE_CLASS,
      ];

      if (this.size !== SIZE_MD) {
        classes.push(`${SPINNER_BASE_CLASS}-${this.size}`);
      }

      if (this.color !== COLOR_SECONDARY) {
        classes.push(`${SPINNER_BASE_CLASS}-${this.color}`);
      }

      return classes;
    },
  },
};
</script>
